import { registerStoreModule } from '@/web/store'
import productVariations from '@/web/store/modules/product-variations'
import PRODUCT_VARIATIONS from '@/web/store/types/product-variations'

registerStoreModule('product-variations', productVariations)

export default PRODUCT_VARIATIONS
